import TripsGenerator from "../../components/trip-planning/TripPlanner";

export default function GenerateTrips() {
  return <TripsGenerator />;
}
